function removeParamFromUrl (name) {
  setTimeout(() => {
    const link = new URL(window.location.href);
    link.searchParams.delete(name);
    window.history.replaceState({}, '', link);
  }, 0)
}

export default removeParamFromUrl
